import styled from 'styled-components';
import { colors } from '@chegg-ui/theme';
var grey = colors.grey;
export var VerticalDivider = styled.div.withConfig({
  componentId: "sc-takv5c-0"
})(["align-self:stretch;width:0;border-left:1px solid ", ";display:inline-flex;margin:0px 5px;"], grey);
export var DefaultMopViewWrapper = styled.div.withConfig({
  componentId: "sc-takv5c-1"
})(["margin-bottom:15px;align-items:center;flex-direction:row;display:flex;& > [role='img']{flex-shrink:0;}"]);
export var LinkWrapper = styled.div.withConfig({
  componentId: "sc-takv5c-2"
})(["display:flex;align-items:center;flex-direction:row;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/DefaultMopView/styled.js
// module id = 4569
// module chunks = 11